import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.access-bg {
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 40%, #2563eb 100%);
}

.access-card {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95);
}

.floating-shape {
  border-radius: 50%;
  opacity: 0.08;
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-20px) rotate(5deg);
  }
  66% {
    transform: translateY(10px) rotate(-3deg);
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public loginData: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) {
            location.href = "/";
            return;
        }
    }

    public async switchView(view: string) {
        this.view = view;
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.loginData));

        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let res = await wiz.call("login", user);

        if (res.code == 200) {
            location.href = "/";
        } else {
            await this.alert(res.data?.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public async signup() {
        let user = JSON.parse(JSON.stringify(this.signupData));
        if (!user.name) { await this.alert("이름을 입력해주세요."); return; }
        if (!user.email) { await this.alert("이메일을 입력해주세요."); return; }
        if (!user.password || user.password.length < 8) { await this.alert("비밀번호는 8자 이상 입력해주세요."); return; }
        if (user.password !== user.passwordConfirm) { await this.alert("비밀번호가 일치하지 않습니다."); return; }

        let { code, data } = await wiz.call("signup", user);
        if (code == 200) {
            await this.alert("회원가입이 완료되었습니다. 로그인해주세요.", 'success');
            this.signupData = { name: '', email: '', password: '', passwordConfirm: '' };
            await this.switchView('login');
        } else {
            await this.alert(data.message || "회원가입에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;